:host {
  display: flex;
  flex-direction: column;
  background: var(--aha-gray-600);
  border-top-left-radius: var(--Common--border-radius);
  border-top-right-radius: var(--Common--border-radius);
}

#content {
  padding: var(--spacer-5) var(--spacer-7);
  box-sizing: border-box;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  overflow: auto;
}
#content slot::slotted(img) {
  border-radius: var(--Common--border-radius);
}

slot[name='header']::slotted(aha-modal-header) {
  border-bottom: 1px solid var(--theme-primary-border);
}
